import { CSSProperties } from 'react';

export type WaveUpIconProps = {
  fill: string;
  height: number | string;
  width: number | string;
  style?: CSSProperties;
};

const WaveUpIcon = ({ fill, height, width, ...props }: WaveUpIconProps) => (
  <svg height={height} width={width} {...props}>
    <g>
      <path
        d="M0,50Q32.55416666666667,81.08333333333333,37.5625,81.25C45.074999999999996,81.5,67.6125,55.625,75.125,52.5S105.175,49.25,112.6875,50S142.7375,61.25,150.25,60S180.29999999999998,41.625,187.81249999999997,37.5S217.8625,21.25,225.375,18.75S255.42499999999995,10,262.93749999999994,12.5S292.9875,41.875,300.5,43.75S330.55,33.125,338.0625,31.25S368.11249999999995,24.375,375.62499999999994,25S405.675,35,413.1875,37.5Q418.1958333333333,39.166666666666664,450.75,50L450.75,100Q418.1958333333333,100,413.1875,100C405.675,100,383.13749999999993,100,375.62499999999994,100S345.575,100,338.0625,100S308.0125,100,300.5,100S270.44999999999993,100,262.93749999999994,100S232.8875,100,225.375,100S195.32499999999996,100,187.81249999999997,100S157.7625,100,150.25,100S120.2,100,112.6875,100S82.6375,100,75.125,100S45.074999999999996,100,37.5625,100Q32.55416666666667,100,0,100Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default WaveUpIcon;
